var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "76.000000pt",
    viewBox: "0 0 88.000000 76.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,76.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 746 c-4 -10 54 -83 160 -203 l166 -188 0 -132 0 -133 80 -40 c126 -64 120 -71 120 134 l0 173 165 188 c91 104 164 193 162 199 -3 8 -135 12 -426 14 -362 2 -422 0 -427 -12z m796 -23 c0 -5 -68 -84 -150 -178 l-149 -170 -1 -162 c0 -105 -4 -163 -10 -163 -6 0 -37 14 -70 30 l-60 30 0 131 0 130 -150 170 c-82 94 -150 175 -150 180 0 5 148 9 370 9 204 0 370 -3 370 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.2dd8c79a32dae40e4082eb4746858f30.svg";
export { ForwardRef as ReactComponent };